// Soft Limit - anything over this may be cut off
// Hard Limit - anything over this will be truncated
export const pushNotificationMessageSoftLimit = 178;
export const pushNotificationMessageHardLimit = 240;

export const pushNotificationTitleSoftLimit = 65;
export const pushNotificationTitleHardLimit = 100;
